import {isRTL} from '../../../Localization';
import {TransactionValuesVer2301} from '../consts/monitoring/monitoring';
import {texts} from './v24texts';
import {AnnouncementItems} from '../consts/types';
import formDesignEng from '../../../images/form_design_ENG.png';
import formDEsignHeb from '../../../images/form_design_HEB.png';
import chartAnalytics from '../../../images/chartAnalytics.png';
import welcome from '../../../images/welcomPriority.png';
import BPM_ENG from '../data/lottieContent/BPM eng.json';
import BPM_HEB from '../data/lottieContent/BPM heb.json';
import PartModal_ENG from '../data/lottieContent/part modal eng.json';
import PartModal_HEB from '../data/lottieContent/part modal heb.json';
//import EOY_HEB from '../data/lottieContent/EOY1.json';
//import EOY_ENG from '../data/lottieContent/EOY2.json';

const isRtl = isRTL();

export const ver2401: () => AnnouncementItems[] = () => {
    return [
        {
            type: 'Welcome',
            title: texts.welcomePageTitle,
            content: texts.welcomePageText,
            additionalContent: welcome,
            monitoring: {
                forwardBtn: TransactionValuesVer2301.AnnouncementShowMe,
                backwardBtn: TransactionValuesVer2301.AnnouncementNoThanks,
                closeBtn: TransactionValuesVer2301.AnnouncementClose1
            },
            linkText: texts.showMe,
            linkUrl: isRtl
                ? 'https://support.priority-software.com/en/kb/LBI2400611/Hebrew'
                : 'https://support.priority-software.com/en/kb/LBI2400610/English'
        },
        {
            type: 'Content',
            title: texts.chartTitle,
            content: texts.chartText,
            additionalContent: chartAnalytics,
            monitoring: {
                forwardBtn: TransactionValuesVer2301.AnnouncementNext2,
                closeBtn: TransactionValuesVer2301.AnnouncementClose2
            },
            linkText: texts.showMe,
            linkUrl: isRtl
                ? 'https://support.priority-software.com/en/kb/LBI2400611/Hebrew'
                : 'https://support.priority-software.com/en/kb/LBI2400610/English'
        },
        {
            type: 'Content',
            title: texts.bpmTitle,
            content: texts.bpmText,
            lottieContent: isRtl ? BPM_HEB : BPM_ENG,
            monitoring: {
                forwardBtn: TransactionValuesVer2301.AnnouncementNext4,
                closeBtn: TransactionValuesVer2301.AnnouncementClose4
            },
            linkText: texts.showMe,
            linkUrl: isRtl
                ? 'https://support.priority-software.com/en/kb/LBI2400611/Hebrew'
                : 'https://support.priority-software.com/en/kb/LBI2400610/English'
        },
        {
            type: 'Content',
            title: texts.formDesignTitle,
            content: texts.formDesignText,
            additionalContent: isRtl ? formDEsignHeb : formDesignEng,
            monitoring: {
                forwardBtn: TransactionValuesVer2301.AnnouncementNext2,
                closeBtn: TransactionValuesVer2301.AnnouncementClose2
            },
            linkText: texts.showMe,
            linkUrl: isRtl
                ? 'https://support.priority-software.com/en/kb/LBI2400611/Hebrew'
                : 'https://support.priority-software.com/en/kb/LBI2400610/English'
        },
        // {
        //     type: 'Content',
        //     title: texts.EOYTitle,
        //     content: texts.EOYText,
        //     lottieContent: isRtl ? EOY_HEB : EOY_ENG,
        //     monitoring: {
        //         forwardBtn: TransactionValuesVer2301.AnnouncementNext3,
        //         closeBtn: TransactionValuesVer2301.AnnouncementClose3
        //     },
        //     linkText: texts.showMe,
        //     linkUrl: isRtl
        //         ? 'https://support.priority-software.com/en/kb/LBI2400275/Hebrew#:~:text=מרכז האוטומציות – חוויה חדשנית ואינטואיטיבית לחוקים עסקיים%2C חוקים למילוי אוטומטי'
        //         : 'https://support.priority-software.com/en/kb/LBI2400274/English#:~:text=Automations Hub – A new intuitive experience for business %26 autofill rules'
        // },

        {
            type: 'Content',
            title: texts.partDialogTitle,
            content: texts.partDialogText,
            lottieContent: isRtl ? PartModal_HEB : PartModal_ENG,
            monitoring: {
                forwardBtn: TransactionValuesVer2301.AnnouncementNext3,
                closeBtn: TransactionValuesVer2301.AnnouncementClose3
            },
            linkText: texts.showMe,
            linkUrl: isRtl
                ? 'https://support.priority-software.com/en/kb/LBI2400611/Hebrew'
                : 'https://support.priority-software.com/en/kb/LBI2400610/English'
        }
    ];
};
